// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppleFilledSvg from "@fishx/icons-svg/es/asn/AppleFilled";
import FishxIcon from '../components/FishxIcon';

var AppleFilled = function AppleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppleFilledSvg
  }));
};

AppleFilled.displayName = 'AppleFilled';
export default React.forwardRef(AppleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AppleFilled.js
// module id = 2004
// module chunks = 0